module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementStartDate),
      expression: "form.disbursementStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementStartDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.disbursementStartDate)
    },
    on: {
      "change": _vm.loadData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementEndDate),
      expression: "form.disbursementEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementEndDate",
      "placeholder": "Disbursment End Date"
    },
    domProps: {
      "value": (_vm.form.disbursementEndDate)
    },
    on: {
      "change": _vm.loadData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startEmiEndDate),
      expression: "form.startEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "startEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.startEmiEndDate)
    },
    on: {
      "change": _vm.loadData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.endtEmiEndDate),
      expression: "form.endtEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "endEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.endtEmiEndDate)
    },
    on: {
      "change": _vm.loadData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "endtEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Select Branch")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadData]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                      Select Company Branch\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(branch) {
    return _c('option', {
      key: branch.id,
      domProps: {
        "value": branch.id
      }
    }, [_vm._v("\n                      " + _vm._s(branch.name) + "\n                    ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("Total amt: " + _vm._s(_vm.totalAmt))])]), _vm._v(" "), _c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Loan Disbursed")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body table-sm"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed",
      "line-numbers": true,
      "pagination-options": {
        enabled: true,
        perPage: 10,
        perPageDropdown: [10, 20, 30],
      },
      "search-options": {
        enabled: true,
        trigger: 'enter',
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'plan_name') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.planName(props.row.plan)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'plan_amt') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.planAmt(props.row.plan)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'total_amt') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.totalGroupAmt(props.row)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'DisbursementDate') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("myDate")(props.row.disbursementDate)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'EmiStartDate') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("myDate")(props.row.emiStartDate)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'EmiEndDate') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("myDate")(props.row.emiEndDate)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'collection_Center') ? _c('span', [(props.row.collection_center) ? _c('button', {
          staticClass: "btn btn-xs btn-info",
          on: {
            "click": function($event) {
              return _vm.viewGroupMember(props.row.collection_center.id)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(props.row.collection_center.name) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [(_vm.canAccess('loan-disbursement-update')) ? _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.status == 'pending'),
            expression: "props.row.status == 'pending'"
          }],
          staticClass: "btn btn-success btn-xs",
          on: {
            "click": function($event) {
              return _vm.editModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.status == 'disbursed' || props.row.status == 'pending'),
            expression: "props.row.status == 'disbursed' || props.row.status == 'pending'"
          }],
          staticClass: "btn btn-danger btn-xs",
          on: {
            "click": function($event) {
              return _vm.deleteDisbursment(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e(), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.filechargeStatus == 'exclude'),
            expression: "props.row.filechargeStatus == 'exclude'"
          }],
          staticClass: "btn btn-warning btn-xs",
          attrs: {
            "title": "File Charge"
          },
          on: {
            "click": function($event) {
              return _vm.fileChargeModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file"
        })]), _vm._v(" "), _c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.processingFeeStatus == 'exclude'),
            expression: "props.row.processingFeeStatus == 'exclude'"
          }],
          staticClass: "btn btn-warning btn-xs",
          attrs: {
            "title": "Processing Fee"
          },
          on: {
            "click": function($event) {
              return _vm.processingFeeModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-hourglass"
        })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "title": "For Staff"
          },
          on: {
            "click": function($event) {
              return _vm.viewPrintModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-print"
        })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
          staticClass: "btn btn-info btn-xs",
          attrs: {
            "title": "For Customer"
          },
          on: {
            "click": function($event) {
              return _vm.viewPrintCustomerModal(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-hand-o-up"
        })]) : _vm._e()]) : _c('span', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                  ")])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fileChargeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Ledger Account\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                                " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect File Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "processingFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                                Select Ledger Account\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                                " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Processing Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                            "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                            ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                              Show this if the rendering fails.\n                            ")])], 1)])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.created_at)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Customer Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name))]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Customer Code ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.code))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact No ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DOB ")]), _c('td', [_vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gender ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.gender))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Spouse Name  ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.spouseName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Father Name  ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.fatherName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mother Name  ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.motherName))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Address ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _c('td', [_vm._v("District/State/Pincode ")]), (_vm.mem.state) ? _c('td', [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Bank  ")]), _c('td', [(_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("Loan ID ")]), _c('td', [(_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Account Holder ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', [_vm._v("File Charge ")]), (_vm.seeRecord.fileCharge) ? _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.fileCharge))]) : _c('td', [_vm._v(" " + _vm._s(_vm.pl.fileCharge))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Account Number")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%)")]) : _vm._e()]), _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v(_vm._s(_vm.pl.rateOfInterest))]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("IFSC ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td', [_vm._v("Paid Amount ")]), (_vm.seeRecord.loanAmount) ? _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.loanAmount))]) : _c('td', [_vm._v(" " + _vm._s(_vm.pl.amount))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Branch ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]), _vm._v(" "), _c('td', [_vm._v("Processing Fee "), (_vm.pl.processingFeeType != 'fixed') ? _c('span', [_vm._v("(%)")]) : _vm._e()]), (_vm.seeRecord.processingFee) ? _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.processingFee))]) : _c('td', [_vm._v(" " + _vm._s(_vm.pl.processingFee))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_vm._m(9), _vm._v(" "), _c('td', [_vm._v("No of Payments ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.noOfPayments))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Income (INR) ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', [_vm._v("Plan Type ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Occupation ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', [_vm._v("Plan Amount ")]), _vm._v(" "), (_vm.pl.planType === 'normalReduced' || _vm.pl.planType === 'special') ? _c('td', [_vm._v(_vm._s(_vm.showPlanAmtReduced(_vm.pl)))]) : _c('td', [_vm._v(_vm._s(_vm.showPlanAmtNormal(_vm.pl)))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', [_vm._v("Business Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', [_vm._v("Recovery type ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.recoveryType))])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_vm._v("Plan Amount ")]), _vm._v(" "), (_vm.pl.planType === 'normalReduced') ? _c('td', [_vm._v(_vm._s(_vm.pl.amount + _vm.pl.fileCharge + _vm.pl.processingFee))]) : _vm._e(), _vm._v(" "), (_vm.pl.planType != 'normalReduced') ? _c('td', [_vm._v(_vm._s(_vm.pl.amount + (_vm.pl.fileCharge) + (_vm.pl.amount * _vm.pl.processingFee) / 100))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.guarantorName))]), _vm._v(" "), _c('td', [_vm._v("Recovery type ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.recoveryType))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Narration ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.guarantorNarration))]), _vm._v(" "), _c('td', [_vm._v("Type of Interest ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.typeOfInterest))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Address ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.guarantorAddress))]), _vm._v(" "), _c('td', [_vm._v("GST Include ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact Number ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.guarantorPhone))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nominee Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.nomineeName))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nomine Contact Number ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nominee Dob ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.nomineeDob))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("1.मैं /हम समझता हूं /समझते हैं की ऋण की कीमत में केवल दो गटक अथार्थ ब्याज प्रभार- प्रसंस्करण प्रभार शामिल\nहैं।")]), _vm._v(" "), _c('p', [_vm._v("2. मैं/ हम सहमत हूं /है और सहमति देता हूं/ देते हैं की एसमइग्रोथ माइक्रो को किसी भी बैंक कंपनी ट्रस्ट को ब्याज\nसहित या उसके बिना ऋण बेचने का अधिकार है इसके अलावा एसमइग्रोथ को ऋण को सुरक्षित करने का अधिकार है और सभी\nप्रक्रियाओं कर्जदार और जमानतदार दोनों के लिए लागू होगी।")]), _vm._v(" "), _c('p', [_vm._v("3. मैं/ हम इस ऋण सुविधा के उद्देश्य से क्रेडिट ब्यूरो और बीमा कंपनी को अपना व्यक्तिगत विवरण शेयर करने के\nलिए एस एममइग्रोथ माइक्रो फाउंडेशन से सहमत हूं/ है और अपनी सहमति प्रदान करता हूं /देते हैं।")]), _vm._v(" "), _c('p', [_vm._v("4. यह है कि मुझसे कोई मार्जिन मनी या प्रतिभूति जमा नहीं लिया गया है।")]), _vm._v(" "), _c('p', [_vm._v("5. मैंने/ हमने वित्त पोषण सुविधा जैसे हम /मैं एसमइग्रोथ माइक्रो से प्राप्त कर सकता हूं /सकते हैं पर लागू शुल्को और\nप्रभारो को पढ़ और समझ लिया है।")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', [_vm._v("1. मैं /हम घोषणा और पुष्टि करता हूं/ करते हैं कि ऊपर वर्णित जानकारी मेरे /हमारे \nसर्वोत्तम ज्ञान के अनुसार सत्य और सही है और इसमें कुछ भी छुपाया नहीं गया है!\n")]), _vm._v(" "), _c('p', [_vm._v("2. मैं/ हम समझता हूं/ समझते हैं कि smeग्रोथ माइक्रो के पास ऋण आवेदन स्वीकार या अस्वीकार करने का पूर्ण विवेकाधिकार है!")]), _vm._v(" "), _c('p', [_vm._v("3. मैं /हम ग्रामीण /शहरी क्षेत्र के निवासी हैं /हैं और हमारी घरेलू उपाय 100000 /170000से कम है!")]), _vm._v(" "), _c('p', [_vm._v("4. मैं /हम एतदद्वारा मैं सच smeग्रोथ माइक्रो को मेरे/ हमारे केवाईसी विवरण लिपि बंद करने के लिए मेरी हमारी सहमति देता हूं/ देते हैं विवरण में किसी बदलाव के नाम लेने में ऐसी smeग्रोथ माइक्रो को नए विवरण अपडेट करूंगा!")]), _vm._v(" "), _c('p', [_vm._v("5. समय कम 1 से अधिक एसएसजी (सेल्फ हेल्प ग्रुप) या जेएलजी (संयुक्त देयता समूह) के सदस्य नहीं है!")]), _vm._v(" "), _c('p', [_vm._v("6. मैं /हम, केंद्र के सदस्य एतदद्वारा पुष्टि करते हैं कि फॉर्म में भरी गई विषय वस्तु मेरे /हमारे निर्देशों के अनुसार है और मुझे/हमें ज्ञात भाषा में पढ़ाई और समझाई गई है!")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("A. ऋण अनुरोध की प्रक्रिया के लिए smeग्रोथ माइक्रो को 7-10दिन का समय लगेगा!")]), _vm._v(" "), _c('p', [_vm._v("B. सदस्य अपने संबंधित आईडी नंबरों के साथ एक वैद्य फोटो आईडी और पता प्रमाण प्रस्तुत करेगा!")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Application Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Account Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Guarantor Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Plan Amount")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Paid Amount")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }],
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("No. of EMI")])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.mem.guarantorName))]), _vm._v(" "), (_vm.pl.planType === 'normalReduced') ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.amount + _vm.pl.fileCharge + _vm.pl.processingFee))]) : _vm._e(), _vm._v(" "), (_vm.pl.planType != 'normalReduced') ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.amount + (_vm.pl.fileCharge) + (_vm.pl.amount * _vm.pl.processingFee) / 100))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }],
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.noOfPayments))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('table', {
    staticClass: "table"
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                            "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                            ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                              Show this if the rendering fails.\n                            ")])], 1)])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Disbursment Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Customer Name ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " - " + _vm._s(_vm.seeRecord.member.code))]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Contact No ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Adhar Number ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.adhar))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Gender ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.gender))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Spouse Name  ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.spouseName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Father Name  ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.fatherName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Account Number")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.mem.accountNumber))])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Address ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("District/State/Pincode ")]), (_vm.mem.state) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Bank  ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Loan ID ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Account Holder ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("File Charge ")]), (_vm.seeRecord.fileCharge) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.fileCharge))]) : _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.fileCharge))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Account Number")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%)")]) : _vm._e()]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v(" " + _vm._s(_vm.pl.rateOfInterest))]) : _vm._e()])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("IFSC ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Paid Amount ")]), (_vm.seeRecord.loanAmount) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.loanAmount))]) : _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.amount))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Branch ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Processing Fee "), (_vm.pl.processingFeeType != 'fixed') ? _c('span', [_vm._v("(%)")]) : _vm._e()]), (_vm.seeRecord.processingFee) ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.seeRecord.processingFee))]) : _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.processingFee))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_vm._m(20), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("No of Payments ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.noOfPayments))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Income (INR) ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Plan Type ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Occupation ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Plan Amount ")]), _vm._v(" "), (_vm.pl.planType === 'normalReduced' || _vm.pl.planType === 'special') ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.showPlanAmtReduced(_vm.pl)))]) : _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.showPlanAmtNormal(_vm.pl)))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Business Name ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Recovery type ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.recoveryType))])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Name ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Plan Amount ")]), _vm._v(" "), (_vm.pl.planType === 'normalReduced') ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.amount + _vm.pl.fileCharge + _vm.pl.processingFee))]) : _vm._e(), _vm._v(" "), (_vm.pl.planType != 'normalReduced') ? _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(_vm._s(_vm.pl.amount + (_vm.pl.fileCharge) + (_vm.pl.amount * _vm.pl.processingFee) / 100))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Address ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorAddress))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Paid Amount ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.amount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("Contact Number ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.mem.guarantorPhone))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v("No of EMI ")]), _c('td', {
    staticStyle: {
      "border-width": "2px"
    }
  }, [_vm._v(" " + _vm._s(_vm.pl.noOfPayments))])])])])]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(22)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                              ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                              ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                                " + _vm._s(_vm.pl.noOfPayments) + "\n                              ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Amount")]), _vm._v(" : " + _vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Advance Installment")]), _vm._v(" :\n                                " + _vm._s(_vm.pl.acvanceInstallment) + "\n                              ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Panulty ")]), _vm._v(": " + _vm._s(_vm.pl.panulty))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Processing Fee ")]), _vm._v(": " + _vm._s(_vm.pl.processingFee) + "\n                              ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("File Charge")]), _vm._v(" : " + _vm._s(_vm.pl.fileCharge))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Created By")]), _vm._v(" : " + _vm._s(_vm.pl.created_by.name) + "\n                              ")])])])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.planType))])]), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.centerCode))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.code))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Disbursement Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.disbursementDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("EMI Start Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.emiStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Payment Mode")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.paymentMode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(24)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewGroupMember"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(26), _vm._v(" "), _c('tbody', _vm._l((_vm.groupMembers), function(groupMem) {
    return _c('tr', {
      key: groupMem.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(groupMem.member.name))])]), _vm._v(" "), _c('td', [_c('a', [_vm._v(" " + _vm._s(groupMem.member.code))])])])
  }), 0)])])])])])])]), _vm._v(" "), _vm._m(27)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Charge")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                              Payment Date\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  COLLECT\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Processing Fee Charge")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                              Payment Date\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  COLLECT\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "6",
      "colspan": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "150px",
      "height": "180px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer "), _c('br'), _vm._v(" & "), _c('br'), _vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Address Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Guarantor Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('strong', [_vm._v("Nominee Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("घोषणा")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Note")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Branch Manager Signature")]), _vm._v(" "), _c('th', [_vm._v("Customer Signature")]), _vm._v(" "), _c('th', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "rowspan": "5",
      "colspan": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "150px",
      "height": "180px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer "), _c('br'), _vm._v(" & "), _c('br'), _vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Address Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "border-width": "2px",
      "border-style": "solid"
    }
  }, [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Guarantor Details")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Group Member Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Code")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74da0bd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/GroupDisbursment.vue
// module id = 895
// module chunks = 0